import React from 'react';
import ReactMarkdown from 'react-markdown';
import { stabilizeMarkdownForStreaming } from '../utils/markdown';

// Simple error boundary to prevent markdown parser crashes from breaking the UI
class MarkdownErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch() {}
  componentDidUpdate(prevProps) {
    if (prevProps.content !== this.props.content && this.state.hasError) {
      // Reset error state when content changes
      // so we can attempt to render markdown again
      // (common when a partial stream becomes complete)
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ hasError: false });
    }
  }
  render() {
    if (this.state.hasError) {
      const safeText = stabilizeMarkdownForStreaming(this.props.content || '');
      return <ReactMarkdown remarkPlugins={[]}>{safeText}</ReactMarkdown>;
    }
    return this.props.children;
  }
}

export default MarkdownErrorBoundary;
